import { Box, Container, Typography } from "@mui/material"
import Images from "../../assets/js/Images"
import { Fragment } from "react"

function TopBannerB({ bannerImg, headline, subHeadline, children }) {

  return (
    <Fragment>
      <Box
        component="section"
        sx={{
          bgcolor: "dark.main",
          backgroundSize: "cover",
          backgroundPosition: { xs: "top left", md: "center" },
          backgroundImage: `url("${bannerImg || Images?.slideImage3}")`,
        }}
      >
        <Box
          sx={{
            bgcolor: "transparent",
            py: { xs: 12, lg: 15 },
          }}
        >
          <Container maxWidth={false} fixed>
            <Box
              sx={{
                gap: 2.5,
                color: "white",
                height: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                component="h2"
                variant="topBannerTitle"
              >{headline}
              </Typography>
              <Typography
                variant="topBannerSubTitle"
              >{subHeadline}
              </Typography>
              {children}
            </Box>
          </Container>
        </Box>
      </Box>
    </Fragment>
  )
}

export default TopBannerB